import { NAVBARCLICKED } from "../actionTypes";
import { NavProps } from "../../interfaces/actions.interface";

export const landingNavbarOpen = (): NavProps => {
  return { type: NAVBARCLICKED };
};
